export default "__VITE_ASSET__B$pWkduJ__"